import Api from '../../utils/api';
import {
  API_REDEMPTION_DETAILS,
  API_REDEMPTION_APPROVE,
  API_REDEMPTION_REJECT,
} from '../../configs/apis';
import {
  API_REDEMPTION_FETCH,
  API_REDEMPTION_FETCH_SUCCESS,
  API_REDEMPTION_APPROVE_REQUEST,
  API_REDEMPTION_APPROVE_SUCCESS,
  API_REDEMPTION_REJECT_REQUEST,
  API_REDEMPTION_REJECT_SUCCESS,
  API_REDEMPTION_FETCH_ERROR,
} from '../types';
import {handleError} from '../error';

export function fetchRedemptionDetails(params) {
  return async (dispatch) => {
    try {
      const {rid} = params;
      dispatch({type: API_REDEMPTION_FETCH, ...params});
      const response = await Api.get(API_REDEMPTION_DETAILS, {}, {rid});
      return dispatch({type: API_REDEMPTION_FETCH_SUCCESS, response});
    } catch (error) {
      return dispatch({type: API_REDEMPTION_FETCH_ERROR, error: error.message});
    }
  };
}

export function approveRedemption(params) {
  return async (dispatch) => {
    try {
      const {rid} = params;
      dispatch({type: API_REDEMPTION_APPROVE_REQUEST, ...params});
      const response = await Api.post(API_REDEMPTION_APPROVE, {}, {rid});
      return dispatch({type: API_REDEMPTION_APPROVE_SUCCESS, response});
    } catch (error) {
      return dispatch(handleError(error));
    }
  };
}

export function rejectRedemption(params) {
  return async (dispatch) => {
    try {
      const {rid} = params;
      dispatch({type: API_REDEMPTION_REJECT_REQUEST, ...params});
      const response = await Api.post(API_REDEMPTION_REJECT, {}, {rid});
      return dispatch({type: API_REDEMPTION_REJECT_SUCCESS, response});
    } catch (error) {
      return dispatch(handleError(error));
    }
  };
}
